export default "__VITE_ASSET__Hyb0bddc__"